import React from "react";
import { Grid, FormControlLabel, Switch, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { fonts, themes } from "../../themes/themes";
import { check_user_permission } from "../../configs/utils";
import { useAppSelector } from "../../../infra/hooks";

interface ICustomSwitchProps {
  checker?: any;
  onChange?: any;
  label?: any;
}

const GreenSwitch = styled(Switch)(() => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#4CAF50",
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#4CAF50",
  },
}));
const CustomSwitch = ({ checker, label, onChange }: ICustomSwitchProps) => {
  const auth_permissions = useAppSelector((state:any) => state.authPermissionSlice?.authPermission);
  return (
    <Grid item xs={12}>
      <FormControlLabel
        key={label}
        control={<GreenSwitch onChange={onChange} checked={checker} disabled={!check_user_permission(auth_permissions,true,"edit")}/>}
        label={
          <Typography
            style={{
              color: "#0000008A",
              fontFamily: fonts.fontFamily,
              fontWeight: "bold",
              fontSize: "14px",
              display: "flex",
            }}
          >
            {label}
          </Typography>
        }
        labelPlacement="end"
      />
    </Grid>
  );
};

export default CustomSwitch;
